import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { Badge } from '@els/els-react--badge';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';

function PatentFamilyExpand({ document, metadata, expandPatentFamilyGroup, collapsePatentFamilyGroup, groupCount = '', isExpanded }) {
  const onExpandClick = useCallback(() => {
    if (!isExpanded) {
      expandPatentFamilyGroup({ document, metadata });
    } else {
      collapsePatentFamilyGroup({ document, metadata });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpanded]);

  return (
    <div className="patent-family-expand">
      <ButtonWithIcon
        data-e2e="patent-family-expand-button"
        aria-expanded={String(isExpanded)}
        type="link"
        sprite={isExpanded ? 'ChevronUp' : 'ChevronDown'}
        iconRight
        onClick={onExpandClick}>
        <span>{isExpanded ? 'Collapse patent family' : 'Expand patent family'}</span>
        <Badge type="subtle" content={groupCount} className="patent-family-expand__badge" />
      </ButtonWithIcon>
    </div>
  );
}

PatentFamilyExpand.propTypes = {
  // Own props
  document: PropTypes.object.isRequired,
  metadata: MetadataPropTypesShape,
  // Selectors / Actions
  expandPatentFamilyGroup: PropTypes.func.isRequired,
  collapsePatentFamilyGroup: PropTypes.func.isRequired,
  groupCount: PropTypes.string,
  isExpanded: PropTypes.bool,
};

export default PatentFamilyExpand;
